import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {TemplateRow} from "./PortfolioTableItem";
import React from "react";

export const TemplateTable = ({templates, onMint, handleArchive, handleDelete, handleViewDocument, emptyListText = "No templates available yet. Start by creating a new one!"}) => {

  return (
    <TableContainer component={Paper} sx={{my: 1, maxWidth: "lg", boxShadow: 0, mx: {xs: "", sm: "auto"} }}>
      <Table sx={{ minWidth: {xs: "auto", sm: 650} }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell padding={"checkbox"}/>
            <TableCell sx={{color: "#666D74 !important"}}>Name</TableCell>
            <TableCell sx={{color: "#666D74 !important", display: {xs: "none", sm: "table-cell"}}}  align="left">Type</TableCell>
            <TableCell sx={{color: "#666D74 !important"}} align="left">Mint</TableCell>
            <TableCell padding={"checkbox"} sx={{color: "#666D74 !important"}} align="left"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {templates?.length === 0 && <TableRow><TableCell colSpan={5}><i>{emptyListText}</i></TableCell></TableRow>}
          {
            templates
              ?.map((nftData, index) => <TemplateRow key={nftData?.uid} nftData={nftData} onMint={onMint}
                                                     handleArchive={handleArchive} handleDelete={handleDelete} handleViewDocument={handleViewDocument}/>)
          }
        </TableBody>
      </Table>
    </TableContainer>
  )
}